import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';
import storage from '../../helpers/StorageHelper';

interface Account {
  parentAccountId: string | null;
  companyAccountId: string;
  companyAccountNumber: number;
  balance: number;
  availableBalance: number;
  minimumAllowedBalance: number;
  unfulfilledRequestSum: number;
}

interface CompanyAccountsState {
  accounts: Account[];
  isError: boolean;
  noPersistance: boolean;
  showNotification: boolean;
  isPrintInvoicePdfForTransferMoney: boolean;
}

const getIsPrintInvoicePdf = (): boolean =>
  !!storage.get('isPrintInvoicePdf') || false;

export const getInitialState = (): CompanyAccountsState => ({
  accounts: [],
  isError: false,
  noPersistance: true,
  showNotification: true,
  isPrintInvoicePdfForTransferMoney: Boolean(getIsPrintInvoicePdf())
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_COMPANY_ACCOUNTS}_REQUEST`]:
    (): Partial<CompanyAccountsState> => ({
      isError: false
    }),
  [`${ApiConstants.LOAD_COMPANY_ACCOUNTS}_SUCCESS`]: (
    state: CompanyAccountsState,
    { payload }: { payload: any[] }
  ): Partial<CompanyAccountsState> => ({
    accounts: payload
  }),
  [`${ApiConstants.LOAD_COMPANY_ACCOUNTS}_FAILURE`]:
    (): Partial<CompanyAccountsState> => ({
      isError: true
    }),
  [`${ApiConstants.LOAD_COMPANY_ACCOUNTS}_CLOSE_NOTIFICATION`]:
    (): Partial<CompanyAccountsState> => ({
      showNotification: false
    }),
  [`${ApiConstants.LOAD_COMPANY_ACCOUNTS}_TOGGLE_PRINT_INVOICE_FOR_PDF`]: (
    state: CompanyAccountsState,
    { payload }: { payload: boolean }
  ): Partial<CompanyAccountsState> => ({
    isPrintInvoicePdfForTransferMoney: payload
  })
});
